import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-phone',
  templateUrl: './icon-phone.component.html',
  styleUrls: ['./icon-phone.component.scss']
})
export class IconPhoneComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
